import Media from '~/api/media';

export default {
    getGalleryNavigation({dispatch}, item = {}) {
        dispatch('buildFilterOptions', item);
        return Media.getGalleryNavigation(item);
    },

    buildPreviewData({state, rootState, commit}, id = null) {
        const mediaData = rootState.media.search.data.find(item => {
            return item.media_id == id
        });

        if (mediaData != null) {
            commit('updatePreview', {
                mediaId: id,
                image: mediaData.preview_image
            });
        }
    },

    buildFilterOptions({state, commit}, item = {}) {
        let filter = {};
        let filterObject = null;

        try {
            filterObject = JSON.parse(item.value);
        } catch(e) {
        } finally {
            filter[item.key] = item.value;
        }

        if (filterObject != null && typeof filterObject == 'object') {
            filter = filterObject;
        }

        commit('updateFilter', filter);
        commit('media/search/updateFilters', state.filter, { root: true });
    }
}